import { Construtor } from './construtor';
import { Usuario } from './usuario';
import { Funcionalidade } from './funcionalidade';

export class UsuarioFuncionalidade implements Construtor<UsuarioFuncionalidade> {

    public idUsuarioFuncionalidade: number;
    public usuario: Usuario;
    public funcionalidade: Funcionalidade;
    public idGrupoAcesso: number;
    public idCliente: number;
    public selecionado: boolean;
    public alterado: boolean;

    constructor(object?: any) {

        if (object !== undefined) {
            if (object instanceof (UsuarioFuncionalidade)) {
                this.copyObject(object);
            } else if (object instanceof (Usuario)) {
                this.usuario = object;
            } else if (object instanceof (Funcionalidade)) {
                this.funcionalidade = object;
            } else {
                this.parseFromJson(object);
            }

            if (!this.modeloCompleto()) {
                return null;
            }
        }
    }

    parseFromJson(usuarioFuncionalidade: any): void {
        this.idUsuarioFuncionalidade = usuarioFuncionalidade.idUsuarioFuncionalidade;
        this.usuario = usuarioFuncionalidade.usuario;
        this.funcionalidade = usuarioFuncionalidade.funcionalidade;
        this.idGrupoAcesso = usuarioFuncionalidade.idGrupoAcesso;
        this.idCliente = usuarioFuncionalidade.idCliente;
    }

    copyObject(usuarioFuncionalidade: UsuarioFuncionalidade): void {
        this.idUsuarioFuncionalidade = usuarioFuncionalidade.idUsuarioFuncionalidade;
        this.usuario = usuarioFuncionalidade.usuario;
        this.funcionalidade = usuarioFuncionalidade.funcionalidade;
        this.idGrupoAcesso = usuarioFuncionalidade.idGrupoAcesso;
        this.idCliente = usuarioFuncionalidade.idCliente;
    }

    modeloCompleto(): boolean {
        return this.usuario !== null && this.funcionalidade !== null && this.idCliente !== null;
    }

    getNewInstance(object?: any): UsuarioFuncionalidade {
        return new UsuarioFuncionalidade(object);
    }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/usuario-funcionalidade.ts